export const mon2num = m => m.replace('.', '').replace('.', '.')

export const currencyFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
})

export default currencyFormatter
